/* global $:false */

import 'jquery-ui/effect-highlight.js'

export default class LoginDialog {
  static init () {
    this.findElements()

    if ((window.gon && window.gon.login) && (window.gon && !window.gon.logged_in)) {
      this.show()
    }

    this.setupBindings()

    this.loginForm.on('ajax:success', () => {
      window.gon.logged_in = true
      window.location.assign((window.location.pathname.replace(/^\/(sv|fi|en)/, '') + window.location.search) || '/')
    })

    this.loginForm.on('ajax:error', event => {
      this.el.find('[data-login-error-messages="true"]').children().hide()
      const xhr = event.detail[2]
      switch (xhr.status) {
        case 412: return this.cookiesRequired.show().effect('highlight', {}, 1000)
        case 401: return this.loginFailed.show().effect('highlight', {}, 1000)
        default: return this.technicalProblems.show().effect('highlight', {}, 1000)
      }
    })
  }

  static findElements () {
    this.el = $('[data-login-dialog-container]')
    this.content = this.el.find('[data-login-dialog-content]')
    this.loginForm = this.el.find('[data-remote-login-form]')
    this.openLoginDialogLink = $('[data-open-login-dialog]')
    this.closeLoginDialogLink = this.el.find('[data-close-login-dialog]')
    this.usernameInput = this.el.find('[data-login-dialog-username]')
    this.cookiesRequired = this.el.find('[data-error-message="cookies-required"]')
    this.loginFailed = this.el.find('[data-error-message="login-failed"]')
    this.technicalProblems = this.el.find('[data-error-message="technical-problems"]')
  }

  static setupBindings () {
    this.hinderCloseWithClickOnContent()
    this.closeWithESCKey()
    this.closeWithClickOutsideOfLoginDialog()
    this.closeWithClickOnCloseSymbol()
    this.openLoginDialog()
  }

  static hinderCloseWithClickOnContent () {
    this.content.on('click', e => e.stopPropagation())
  }

  static closeWithClickOutsideOfLoginDialog () {
    this.el.click(() => {
      this.el.fadeOut()
    })
  }

  static closeWithESCKey () {
    this.el.bind('keyup', e => {
      if (e.keyCode === 27) { this.el.fadeOut() }
    })
  }

  static closeWithClickOnCloseSymbol () {
    this.closeLoginDialogLink.click(() => {
      this.el.fadeOut()
    })
  }

  static openLoginDialog () {
    this.openLoginDialogLink.click(() => {
      this.el.fadeIn()
      this.usernameInput.focus()
    })
  }

  static show () {
    if (window.webkit?.messageHandlers?.loginRequested) {
      window.webkit.messageHandlers.loginRequested.postMessage(true)
    } else {
      this.el.fadeIn()
    }
  }
}
